export default function Footer() {
  return (
    <>
      <footer className="footer">
        <small className="text-muted">
          © 2023 TMS, Inc. All rights reserved.
        </small>
      </footer>
    </>
  );
}
